import { FC, ReactNode } from "react";
import { Content } from "@jobber/components";
import { useBreakpoints } from "@jobber/hooks/useBreakpoints";

type DashboardTabProps = {
    readonly children: ReactNode | ReactNode[],
};

export const DashboardTab: FC<DashboardTabProps> = ({
     children,
}) => {
    let breakpoints = useBreakpoints();

    return (
        <Content type={"div"} spacing={"base"}>
            <div
                style={{
                    paddingTop: "10px",
                }}
            >
                <div id="errors"></div>
                {children}
            </div>
        </Content>
    );
};

export default DashboardTab;